import { COLORS, TYPE } from './tokens'

export default function ExportPdfButton() {
  return (
    <button
      onClick={() => window.print()}
      style={{
        ...TYPE.body,
        width: '100%',
        padding: '10px 16px',
        background: 'transparent',
        color: COLORS.bodyText,
        border: `1px solid ${COLORS.hairline}`,
        borderRadius: '4px',
        cursor: 'pointer'
      }}
    >
      Export as PDF
    </button>
  )
}
